import 'bootstrap';

function handleVideoModalEvents(): void {
  const videoModalElement = document.getElementById('videoModal');
  const videoModalContentElement = document.getElementById('videoModalContent');

  if (videoModalElement && videoModalContentElement) {
    videoModalElement.addEventListener('show.bs.modal', (event: Event & { relatedTarget: HTMLElement }) => {
      const relatedTarget = event.relatedTarget;
      if (relatedTarget) {
        switch (relatedTarget.dataset.videoHost) {
          case 'youtube':
            const iframeTitle = relatedTarget.dataset.videoTitle || 'YouTube video player';
            if (relatedTarget.dataset.videoPlaylist === "true") {
              videoModalContentElement.innerHTML = `<iframe src="https://www.youtube.com/embed/videoseries?list=${relatedTarget.dataset.videoId}&controls=0&autoplay=1" title="${iframeTitle}" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`;
            } else {
              videoModalContentElement.innerHTML = `<iframe src="https://www.youtube.com/embed/${relatedTarget.dataset.videoId}?controls=0&autoplay=1" title="${iframeTitle}" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`;
            }
            break;
          default:
            console.warn(`Video host '${relatedTarget.dataset.videoHost}' not supported.`);
            break;
        }
      }
    });

    videoModalElement.addEventListener('hidden.bs.modal', () => {
      videoModalContentElement.innerHTML = '';
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  handleVideoModalEvents();
});
